import React, { useState, useEffect, useContext } from 'react';
import { useForm } from 'react-hook-form';
import toast from 'react-hot-toast';
import { Link, useNavigate } from 'react-router-dom';
import AppContext from "../context/AppContext";


const AdminUsers = () => {
    const { register, handleSubmit, setValue, watch, reset, formState: { errors } } = useForm();
    const [searchValue, setSearchValue] = useState('');
    const [users, setUsers] = useState([]);
    const navigate = useNavigate();
    const { loading, updateLoading } = useContext(AppContext);

    useEffect(() => {
        getAllAdmin()
    }, []);

    const handleSearch = async () => {
        const formData = new FormData();
        formData.append("search", searchValue);

        try {
            const res = await fetch(`${process.env.REACT_APP_BACKEND}/adminusersearch`, {
                method: "POST",
                headers: {
                    Authorization: `${localStorage.getItem("token")}`,
                },
                body: formData,
            });
            const data = await res.json();
            if (!data.status) {
                toast.error("No se encontraron usuarios");
            } else {
                setUsers(data.data || data); // Puede venir en .data o directamente
                toast.success("Usuarios encontrados");
            }
        } catch (err) {
            console.error(err);
            toast.error("Error al buscar usuarios");
        }
    };

    const handleSelectUser = (user) => {
        setValue("usersId", user.id);
        setValue("email", user.email);
        setValue("name", user.name);
        setValue("left", user.balance_binary_left);
        setValue("right", user.balance_binary_right);
        setValue("total_binary_left", user.total_binary_left);
        setValue("total_binary_right", user.total_binary_right);
    };

    const onSubmit = async (data) => {
        console.log('Entro a obsubmit')
        const formData = new FormData();
        Object.keys(data).forEach(key => formData.append(key, data[key]));
        try {
            const res = await fetch(`${process.env.REACT_APP_BACKEND}/adminuserupdate`, {
                method: "POST",
                headers: {
                    Authorization: `${localStorage.getItem("token")}`,
                },
                body: formData,
            });
            const result = await res.json();
            if (result.status) {
                console.log(result)
                toast.success("Usuario actualizado correctamente");
                reset();
                setUsers([])
            } else {
                toast.error(result?.message);
            }
        } catch (err) {
            console.error(err);
            toast.error("Error en la solicitud");
        }
    };

    const getAllAdmin = async () => {
        updateLoading(true);
        fetch(`${process.env.REACT_APP_BACKEND}/admin-packages?page=1&limit=1`, {
            method: "GET",
            headers: {
                Authorization: `${localStorage.getItem("token")}`,
            },
        })
            .then((response) => response.json())
            .then((response) => {
                if (!response.status) {
                    if (response.redirect) {
                        navigate("/");
                    }
                }
                updateLoading(false);

            })
            .catch((error) => {
                console.log(error);
                updateLoading(false);
            });
    };

    const userId = watch("usersId");
    return (
        <div className="p-6">
            <h2 className="text-2xl mb-4 text-white">Buscar Usuario</h2>

            <div className="flex gap-4 mb-6">
                <input
                    type="text"
                    placeholder="Buscar por nombre o email"
                    className="p-2 rounded w-full bg-gray-800 text-white"
                    value={searchValue}
                    onChange={(e) => setSearchValue(e.target.value)}
                />
                <button
                    onClick={handleSearch}
                    className="bg-blue-600 text-white px-4 py-2 rounded"
                >
                    Buscar
                </button>
            </div>

            <table className="w-full text-left text-white mb-8">
                <thead className="border-b border-gray-700">
                    <tr>
                        <th className="p-2">Nombre</th>
                        <th className="p-2">Email</th>
                        <th className="p-2">Balance Izq</th>
                        <th className="p-2">Balance Der</th>
                    </tr>
                </thead>
                <tbody>
                    {users.map((user, index) => (
                        <tr key={index} className="hover:bg-gray-700 cursor-pointer" onClick={() => handleSelectUser(user)}>
                            <td className="p-2">{user.name}</td>
                            <td className="p-2">{user.email}</td>
                            <td className="p-2">{user.balance_binary_left}</td>
                            <td className="p-2">{user.balance_binary_right}</td>
                        </tr>
                    ))}
                </tbody>
            </table>

            <form onSubmit={handleSubmit(onSubmit)} className="text-white space-y-4 bg-zinc-800 p-4 rounded">
                <input type="hidden" {...register("usersId", { required: true })} />

                <div>
                    <label>Email</label>
                    <input className="w-full p-2 rounded bg-gray-900" {...register("email", { required: true })} />
                </div>

                <div>
                    <label>Nombre</label>
                    <input className="w-full p-2 rounded bg-gray-900" {...register("name", { required: true })} />
                </div>
                <div>
                    <label>Contraseña</label>
                    <input className="w-full p-2 rounded bg-gray-900" {...register("password")} />
                </div>

                <div>
                    <label>Balance Binary Left</label>
                    <input className="w-full p-2 rounded bg-gray-900" {...register("left")} />
                </div>
                <div>
                    <label>Total Binary Left</label>
                    <input className="w-full p-2 rounded bg-gray-900 cursor-allowed" {...register("total_binary_left")} disabled />
                </div>
                <div>
                    <label>Balance Binary Right</label>
                    <input className="w-full p-2 rounded bg-gray-900" {...register("right")} />
                </div>
                <div>
                    <label>Total Binary Right</label>
                    <input className="w-full p-2 rounded bg-gray-900 cursor-allowed" {...register("total_binary_right")} disabled />
                </div>
                <button
                    type="submit"
                    disabled={!userId}
                    className={`px-4 py-2 rounded text-white transition-all duration-300 ${userId
                        ? "bg-green-600 hover:bg-green-700 cursor-pointer"
                        : "bg-gray-600 opacity-50 cursor-not-allowed"
                        }`}
                >
                    Guardar Cambios
                </button>
            </form>
        </div>
    );
};

export default AdminUsers;
